/* eslint-disable no-empty */ import _ from 'lodash';
export function cleanLocalStorage() {
    console.log('Cleaning localStorage of LaunchDarkly keys');
    Object.keys(localStorage).forEach(function(key) {
        if (key.startsWith('ld:')) {
            localStorage.removeItem(key);
        }
    });
}
var inMemoryStore = {
    setItem: function setItem(key, value) {
        if (key === 'setItem' || key === 'getItem') {
            throw new Error('Trying to overwrite', key, 'which is a reserved key in storage'); // eslint-disable-line
        }
        inMemoryStore[key] = value;
    },
    getItem: function getItem(key) {
        return inMemoryStore[key];
    },
    removeItem: function removeItem(key) {
        delete inMemoryStore[key];
    }
};
export function setPersistedValue(key, value) {
    var sessionOnly = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, preventReentrancy = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var setValue = function(storage) {
        if (_.isNil(value)) {
            storage.removeItem(key);
        } else {
            storage.setItem(key, JSON.stringify(value));
        }
    };
    // try local storage first
    if (!sessionOnly) {
        try {
            setValue(localStorage);
            return;
        } catch (e) {
            if (e.name === 'QuotaExceededError' && !preventReentrancy) {
                cleanLocalStorage();
                setPersistedValue(key, value, sessionOnly, true);
                return;
            }
        }
    }
    // then session storage
    try {
        setValue(sessionStorage);
        return;
    } catch (e) {}
    // then just use in-memory
    try {
        setValue(inMemoryStore);
    } catch (e) {}
}
export function getPersistedValue(key, defaultValue) {
    try {
        if (typeof sessionStorage !== 'undefined' && sessionStorage[key]) {
            return JSON.parse(sessionStorage[key]);
        }
    } catch (e) {}
    try {
        if (typeof localStorage !== 'undefined' && localStorage[key]) {
            return JSON.parse(localStorage[key]);
        }
    } catch (e) {}
    try {
        if (inMemoryStore[key]) {
            return JSON.parse(inMemoryStore[key]);
        }
    } catch (e) {}
    return defaultValue !== null && defaultValue !== void 0 ? defaultValue : null;
}
/**
 * Gets a persisted value from session storage only (ignores localStorage).
 * Used when compliance requires session-only storage (e.g., Maryland).
 */ export function getSessionPersistedValue(key, defaultValue) {
    try {
        if (typeof sessionStorage !== 'undefined' && sessionStorage[key]) {
            return JSON.parse(sessionStorage[key]);
        }
    } catch (e) {}
    try {
        if (inMemoryStore[key]) {
            return JSON.parse(inMemoryStore[key]);
        }
    } catch (e) {}
    return defaultValue !== null && defaultValue !== void 0 ? defaultValue : null;
}
/**
 * Gets a persisted value from local storage only (ignores sessionStorage), for values that
 * must not be shadowed by a stale session-scoped copy of the same key.
 */ export function getLocalPersistedValue(key, defaultValue) {
    try {
        if (typeof localStorage !== 'undefined' && localStorage[key]) {
            return JSON.parse(localStorage[key]);
        }
    } catch (e) {}
    try {
        if (inMemoryStore[key]) {
            return JSON.parse(inMemoryStore[key]);
        }
    } catch (e) {}
    return defaultValue !== null && defaultValue !== void 0 ? defaultValue : null;
}
export function removePersistedValue(key) {
    var sessionOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    // try local storage first
    if (!sessionOnly) {
        try {
            localStorage.removeItem(key);
            return;
        } catch (e) {}
    }
    // then session storage
    try {
        sessionStorage.removeItem(key);
        return;
    } catch (e) {}
    // then just use in-memory
    try {
        inMemoryStore.removeItem(key);
    } catch (e) {}
}
